export default __webpack_public_path__ + "static/media/wigs.66269fba.png";